import { trpc } from "../trpc";

/**
 * Lists every asset (hydrated) under `folderId` and all of its subfolders in
 * the *current* account. Used by the Copy-to-Another-Account review step to
 * preview the full set of assets that will be copied — `useFolderAssets`
 * alone only returns direct-folder assets, so without this the preview
 * undercounts (and misrepresents) what zsl-api walks server-side.
 *
 * The query is disabled when `folderId` is `undefined` (e.g. when the modal
 * is open for an asset-only export rather than a folder-tree export).
 */
export function useListAssetsInFolderSubtree(
  folderId: string | undefined,
  options?: { ownerId?: string },
) {
  const query = trpc.folder.listAssetsInFolderSubtree.useQuery(
    {
      folderId: folderId ?? "",
      ...(options?.ownerId ? { ownerId: options.ownerId } : {}),
    },
    {
      enabled: !!folderId,
      // Folder contents change rarely during a single modal session and the
      // payload can be large; cache aggressively and let the parent close /
      // reopen drive a refresh if needed.
      staleTime: 1000 * 60 * 5,
    },
  );

  return {
    assets: query.data ?? [],
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}
